import { render, staticRenderFns } from "./InjectionMachineView.vue?vue&type=template&id=29aa01ad&"
import script from "./InjectionMachineView.vue?vue&type=script&lang=js&"
export * from "./InjectionMachineView.vue?vue&type=script&lang=js&"
import style0 from "./InjectionMachineView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports